import transactionHistory from "../services/transaction";
import customers from "../services/customers";
import notification from "../services/notification";
import _ from "lodash";

export default {
    namespaced: true,
    state: {
        loading: false,
        histories: [],
        importUuid: null,
        importUuids: [],
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        errors: null,
        currentPage: 1,
        searching: false,
        categories: [],
        totalPerPage: 1,
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
        customerNames: [],
        all_uuids: [],
        historyCount: 0,
        racksCustomColumns: [],
        customHistories: [],
        uuidsWithKeyAccounts: null,
        summaryCount: {},
        initialPageCount: 0
    },
    mutations: {
        loading(state, payload) {
            state.loading = payload;
        },
        clearHistory(state) {
            state.histories = [];
        },
        histories(state, histories) {
            state.histories = histories;

            _.forEach(state.histories, function(history, key) {
                let index = _.findIndex(state.customerNames, function(o) {
                    return o.uuid == history.customer_uuid;
                });
                state.histories[key].name =
                    index > -1 && state.customerNames[index].name != null
                        ? state.customerNames[index].name
                        : "";
            });

            if (
                state.histories != null &&
                state.uuidsWithKeyAccounts !== null
            ) {
                let companyCodeList =
                    state.uuidsWithKeyAccounts.company_code_list;
                let customers = state.histories.map(obj => {
                    let customer = {};
                    customer["transaction_uuid"] = obj.transaction_uuid;
                    customer["created_at"] = obj.created_at;
                    customer["customer_name"] = obj.customer_name;
                    customer["mobile"] = obj.mobile;
                    customer["registration_date"] = "";
                    customer["customer_uuid"] = obj.customer_uuid;
                    customer["points_mechanic"] = obj.points_mechanic;
                    customer["card_no"] = obj.card_no;
                    customer["membership_id"] = obj.membership_id;
                    customer["is_guest"] = obj.is_guest;
                    customer["details"] = obj.details;
                    customer["transaction_type"] = obj.transaction_type;
                    customer["amount"] = obj.amount;
                    customer["points"] = obj.points;
                    customer["employee_id"] = obj.employee_id;
                    customer["employee_name"] = obj.employee_name;
                    customer["employee_brand"] = obj.employee_brand;
                    customer["employee_branch"] = obj.employee_branch;
                    customer["reward"] = obj.reward;
                    customer["price"] = obj.price;
                    customer["message"] = obj.message;
                    customer["transaction_status_type"] =
                        obj.transaction_status_type;

                    if (obj.medpadala_code)
                        customer["medpadala_code"] = obj.medpadala_code;
                    if (obj.medpadala_amount)
                        customer["medpadala_amount"] = obj.medpadala_amount;

                    for (
                        let cIndex = 0;
                        cIndex < companyCodeList.length;
                        cIndex++
                    ) {
                        if (
                            obj.customer_uuid ==
                            companyCodeList[cIndex].customer_uuid
                        )
                            customer["company_code"] =
                                companyCodeList[cIndex].company_code;
                    }
                    return customer;
                });
                state.histories = customers;
            }
        },
        setImportUuid(state, importUuid) {
            state.importUuid = importUuid;
        },
        setImportUuids(state, importUuid) {
            state.importUuids.push(importUuid);
        },
        pagination(state, pagination) {
            state.totalPerPage = pagination.list.length;
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.totalPerPage > 0
                        ? state.initialPageCount *
                                state.prevPage +
                            1
                        : 0;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },
        categories(state, categories) {
            state.categories = categories;
        },
        searching(state, searching) {
            state.searching = searching;
        },
        errors(state, errors) {
            state.errors = errors;
        },
        setInitialPageCount(state, list) {
            state.initialPageCount = list.length;
        },
        setCustomerNames(state, list) {
            list.forEach(function(value) {
                let uuid = value.uuid;

                let fname = value.firstname == null ? "" : value.firstname;
                let lname = value.lastname == null ? "" : value.lastname;

                let name = fname + " " + lname;

                let obj = {};

                obj["uuid"] = uuid;
                obj["name"] = name;

                state.customerNames.push(obj);
            });
        },
        setAllUuids(state, list) {
            state.all_uuids = list.customer_uuids;

            state.all_uuids = JSON.stringify(state.all_uuids);
        },
        setHistoryCount(state, count) {
            state.historyCount = count;
        },
        setRacksCustomColumns(state, list) {
            state.racksCustomColumns = list;
        },
        customHistories(state, customHistories) {
            state.customHistories = customHistories;
        },
        uuidsWithKeyAccounts(state, uuidsWithKeyAccounts) {
            state.uuidsWithKeyAccounts = uuidsWithKeyAccounts;
        },
        resetErrors(state) {
            state.errors = null;
        },
        removeUuidFromiImportUuids(state, importUuid) {
            state.importUuids = state.importUuids.filter(
                uuid => uuid !== importUuid
            );
        },
        setSummaryCount(state, summaryCount) {
            state.summaryCount = summaryCount;
        },
        setHistories(state, histories) {
            state.histories = histories;
        }
    },
    actions: {
        async getHistory({ commit, dispatch, state }, param) {
            commit("loading", true);

            try {
                // let _this = this;
                await commit("clearHistory", []);
                let response = await transactionHistory.getHistoryV2(param);
                if (param.page == 1) {
                    await commit("setInitialPageCount", response.list);
                }
                
                await commit("setHistories", response.list);
                await commit("pagination", response);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getCSVTemplate({ commit }, page) {
            commit("loading", true);

            try {
                await transactionHistory.getCSVTemplate(page);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getCustomerList({ commit }, uuids) {
            commit("loading", true);

            try {
                let param = {
                    customer_uuids: uuids
                };

                let response = await customers.getCustomerInfos(param);

                await commit("setCustomerNames", response.customers);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getCategories({ commit }) {
            commit("loading", true);

            try {
                let response = await transactionHistory.getCategories();
                commit("categories", response.categories);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async importTransactions({ commit }, param) {
            commit("loading", true);

            try {
                let response = await transactionHistory.importTransactions(
                    param
                );
                commit("setImportUuid", response.data.import_uuid); // Set import data for initial notification
                commit("setImportUuids", response.data.import_uuid); // List of UUIDs being uploaded
            } catch (errors) {
                notification.warning(
                    "Oops, cannot import transaction history list."
                );
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async resetErrors({ commit }) {
            commit("resetErrors");
        },
        removeUuidFromiImportUuids({ commit, state }, uuid) {
            commit("removeUuidFromiImportUuids", uuid);
        },
        async search({ commit, state }, param) {
            commit("loading", true);
            commit("clearHistory");
            try {
                let response = await transactionHistory.search(
                    param.apiFields,
                    param.page
                );

                if (param.page == 1) {
                    await commit("setInitialPageCount", response.list);
                }

                commit("pagination", response);
                commit("histories", response.list);
                commit("searching", true);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async filterByDate({ commit }, param) {
            commit("loading", true);
            commit("clearHistory");
            try {
                let response = await transactionHistory.filterByDate(
                    param.apiFields,
                    param.page
                );

                commit("pagination", response);
                commit("histories", response.list);
                commit("searching", true);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async filterByDateFull({ commit }, param) {
            commit("loading", true);
            commit("clearHistory");

            try {
                let response = await transactionHistory.filterByDateFull(
                    param.apiFields,
                    param.page
                );

                commit("pagination", response);
                commit("histories", response.list);
                commit("searching", true);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getCustomerHistory({ commit, state }, param) {
            commit("loading", true);
            commit("histories", []);
            try {
                let response = await transactionHistory.getCustomerHistory(
                    param.apiFields,
                    param.apiFields.page
                );
                commit("pagination", response);
                commit("histories", response.list);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },

        async getCustomerUuids({ commit }) {
            let response = await transactionHistory.getCustomerUuid();
            let uuidsWithKeyAccounts = await customers.getApprovedCompanyCodeList(
                response
            );
            commit("setAllUuids", response);
            commit("uuidsWithKeyAccounts", uuidsWithKeyAccounts);
        },

        async exportHistory({ commit }, param) {
            commit("errors", null);

            try {
                await transactionHistory.export(param);
                notification.success(
                    "Your data is being exported. You will receive it via email."
                );
            } catch (errors) {
                commit("errors", errors);
                notification.warning("Oops, cannot export transaction history.");
            } 
        },
        async getCustomerHistoryCount({ commit }, param) {
            try {
                let response = await transactionHistory.getCustomerHistoryCount(
                    param.uuid
                );

                commit("setHistoryCount", response.transaction_count);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getImportsStatus({ commit }, param) {
            try {
                let response = await transactionHistory.getImportsStatus(param);
                return response.data;
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getRacksCustomColumns({ commit }) {
            commit("loading", true);

            try {
                let racksCustomColumns = await transactionHistory
                    .getRacksCustomColumns()
                    .then(value => {
                        return value.columns.map(column => {
                            if (column == "transaction_uuid") {
                                return {
                                    // key: column,
                                    // label: "Transaction ID"
                                };
                            } else if (column == "item_id") {
                                return {
                                    key: column,
                                    label: "Item ID"
                                };
                            } else if (column == "transaction_number") {
                                return {
                                    key: column,
                                    label: "Transaction By Day-Part"
                                };
                            } else if (column == "transaction_by_day") {
                                return {};
                            } else {
                                return {
                                    key: column
                                };
                            }
                        });
                    });
                commit("setRacksCustomColumns", racksCustomColumns);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getCustomHistory({ commit, dispatch, state }, param) {
            commit("loading", true);

            try {
                let response = await transactionHistory.getCustomHistory(param);
                if (param.page == 1) {
                    await commit("setInitialPageCount", response.list);
                }
                // await dispatch("getCustomerList", state.all_uuids);
                await commit("customHistories", response.list);
                await commit("pagination", response);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getSummaryCount({ commit }, params = {}) {
            try {
                let response = await transactionHistory.getSummaryCount(params);
                commit("setSummaryCount", response.data);
            } catch (errors) {
                console.log(errors);
            }
        }
    }
};
